import { lazy } from 'react';

export const RoutingPage = lazy(() =>
  import('@/features/routing/RoutingPage').then((module) => ({ default: module.RoutingPage })),
);
